import React, { useEffect } from "react";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import { useCountdown } from "../../../hooks/useCountdown";

const ExpiredNotice = () => {
  return (
    <div className="expired-notice">
      <span>Expired!!!</span>
      <p>Please select a future date and time.</p>
    </div>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds, isTextInsideBox }) => {
  return (
    <div className="show-counter">
      {days > 0 && (
        <>
          <DateTimeDisplay
            value={days < 0 ? 0 : days}
            type={"hari"}
            isTextInsideBox={isTextInsideBox}
          />
          <span className="equal">:</span>
        </>
      )}

      <DateTimeDisplay
        value={hours < 0 ? 0 : hours}
        type={"jam"}
        isTextInsideBox={isTextInsideBox}
      />
      <span className="equal">:</span>
      <DateTimeDisplay
        value={minutes < 0 ? 0 : minutes}
        type={"menit"}
        isTextInsideBox={isTextInsideBox}
      />

      {days <= 0 && (
        <>
          <span className="equal">:</span>
          <DateTimeDisplay
            value={seconds < 0 ? 0 : seconds}
            type={"detik"}
            isTextInsideBox={isTextInsideBox}
          />
        </>
      )}
    </div>
  );
};

const DateTimeDisplay = ({ value, type, isTextInsideBox }) => {
  return (
    <div className="countdown-container">
      <div className={"countdown"}>
        <p className="!text-[13px]">{value}</p>
        {isTextInsideBox && <span id="alt">{type}</span>}
      </div>
      {!isTextInsideBox && <span className="!text-[11px]">{type}</span>}
    </div>
  );
};

const CountdownTimer = ({
  targetDate,
  isTextInsideBox = false,
  expiredAction,
}) => {
  const { days, hours, minutes, seconds } = useCountdown(targetDate);
  const { setPageMode } = usePageContextFunction();

  const isExpired = days + hours + minutes + seconds <= 0;

  useEffect(() => {
    if (isExpired) {
      expiredAction?.();
      setPageMode("banner");
    }
  }, [isExpired]);

  return (
    <ShowCounter
      days={days}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
      isTextInsideBox={isTextInsideBox}
    />
  );
};

export default CountdownTimer;
